import type { Maybe } from "@entrilia/shared/types.ts";
import type {
  BiAggregation,
  NumberFormatterOptions,
} from "../../../../../../../../../api/types/fieldConfigurationTypes.ts";
import type { DimensionField } from "../../../../../../../../../api/types/svTypes.ts";
import { defaultCountAggregationFormat } from "../../../../../formatters/NumberFormatter.ts";
import { isCountRelatedAggregation } from "../../../../../utilities/aggregationHelper.ts";

/**
 * Returns a default format based on whether the given aggregation is count-related or
 * uses the field's default format.
 */
export const getDefaultFormatByAggregation = (currentField: DimensionField, aggregation: Maybe<BiAggregation>) => {
  if (isCountRelatedAggregation(aggregation)) {
    return defaultCountAggregationFormat;
  }

  return currentField.meta.defaultFormat as NumberFormatterOptions;
};
